import React from 'react';
import { Route, Routes, useLocation, useNavigate, useParams, useSearchParams } from 'react-router-dom';
import SystemClient from './system/SystemClient';
import Environment from './lib/Environment';
import MessageCourier from './lib/MessageCourier';
import BasicBlockUI from './components/Common/BasicBlockUI';
import XhrRequestError from './lib/XhrRequestError';
import XhrErrorListener from './lib/XhrErrorListener';
import { NotFound } from './components/NotFound';
import Base from './components/Common/Layout/Base';
// import TorneoDetailView from "./components/Torneo/TorneoView";
import { IDropdownOption } from '@fluentui/react';
import useAsyncDataCourier from './common/custom-hooks/useAsyncDataCourier';
import { WizardRegistroEntrenador } from './components/WizardRegistroEntrenador/WizardRegistroEntrenador';
import { ConfirmacionRegistro } from './components/ConfirmacionRegistro';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3';

export interface AppContext {
  system: SystemClient;
  courier: MessageCourier;
  changeBlockUI: (v: boolean) => void;
}

interface IRouterContextProps {
  system: SystemClient;
  environment: Environment;
  courier: MessageCourier;
}

const AppInRouterContext = (props: IRouterContextProps) => {
  const [block, setBlock] = React.useState(false);
  const [token, setToken] = React.useState('');

  const changeBlockUI = (shouldBlock: boolean) => {
    setBlock(shouldBlock);
  };

  const captcha = useGoogleReCaptcha();

  const getToken = async () => {
    return captcha.executeRecaptcha ? await captcha.executeRecaptcha(props.environment.captchaAction()) : '';
  };

  const appContext: AppContext = {
    system: props.system,
    changeBlockUI: changeBlockUI,
    courier: props.courier,
  };

  return (
    <>
      <>
        <BasicBlockUI blockUI={block} />
        <Routes>
          <Route path="/" element={<Base appContext={appContext} />}>
            {/* <Route path=":id" element={<ClubMain federacion={federacion} appContext={appContext} />} /> */}
            <Route path="" element={<WizardRegistroEntrenador getToken={getToken} appContext={appContext} />} />
            <Route path="/confirmacion/:token" element={<ConfirmacionRegistro appContext={appContext} />} />
            <Route path="*" element={<NotFound />} />
          </Route>
        </Routes>
      </>
    </>
  );
};

export default AppInRouterContext;
